/**
 * 用户账户相关
 */
import api from '@/api'

let bi = {}


bi.today = async function () {
    return api.get(`/bi/today`)
}

bi.getBI = async function (data) {
    return api.get(`/bi/getBI`, data)
}

bi.all = async function (data) {
    return api.get(`/bi/all`, data)
}

bi.syncBalanceInfo = async function (data) {
    return api.get(`/bi/syncBalanceInfo`, data)
}

bi.balanceSnapshot = async function (data) {
    return api.get(`/bi/balanceSnapshot`, data)
}


export default bi
